import { Cookie } from "./CookieBanner.styles"

export const CookieBannerLine = ({ title, text, cookieType, settings, setSettings }) => {

  const isCookieTypeDefined = typeof settings[cookieType] !== 'undefined';

  return (
    <Cookie.FlexCol gap={20}>
      <Cookie.SubTitle>{title}</Cookie.SubTitle>
      <Cookie.Line>
        <Cookie.Text style={{ marginBottom: 0, fontSize: 14 }}>
          {text}
        </Cookie.Text>
        {isCookieTypeDefined && <Cookie.ToggleButtonWrapper isActive={settings[cookieType]} onClick={() => setSettings(prev => ({
          ...prev,
          [cookieType]: !prev[cookieType]
        }))} />}
      </Cookie.Line>
    </Cookie.FlexCol>
  )

}